import { useCallback } from "react";
import api, { serializeSearchParams } from "../../utils/api";
import qs from "qs";
export default function useLazyTree({
  config,
  treeApiRef,
  defaultParams = {},
}) {
  const getTreeItems = useCallback(
    async (parentId) => {
      const typeHierarchy = config.map(({ type }) => type);
      const parent = parentId ? treeApiRef.current.getItem(parentId) : null;
      const parentTypeIndex = parent ? typeHierarchy.indexOf(parent.type) : -1;
      const typeConfig = config.find(
        (val) => val.type == typeHierarchy[parentTypeIndex + 1]
      );
      if (!typeConfig) {
        return [];
      }
      const { type, baseUrl, getParams, getLabel, getChildrenCount, ...other } =
        typeConfig;
      const params = {
        ...defaultParams,
        ...(getParams ? getParams(parent) : {}),
      };

      const finalUrl = `${baseUrl}${qs.stringify(
        serializeSearchParams(params),
        {
          addQueryPrefix: true,
        }
      )}`;
      const response = await api.get(finalUrl);
      const rows = response.data.data;

      const items = rows.map((row) => ({
        id: row.uuid,
        label: getLabel(row),
        childrenCount: getChildrenCount(row),
        type: type,
        ...other,
        data: row,
      }));

      return items;
    },
    [config, treeApiRef, defaultParams]
  );

  return { getTreeItems, getChildrenCount: (item) => item.childrenCount };
}
